import React from "react";

import { CloseOutlined } from "@ant-design/icons";
import { Modal } from "antd";

import topupPoolAlertIllustration from "../../../../../assets/images/subscriptions/start-topup-pool-alert-illustration.png";

import "./StartTopupPoolAlertModal.css";

export default function StartTopupPoolAlertModal({
  open,
  onClose,
  title = "You're now using Top-up Pool",
  description,
  poolTests = 0,
  subscriptionStatus = "Unchanged",
  billingCycle,
  illustration = topupPoolAlertIllustration,
}) {
  const cycleText = String(billingCycle || "").trim().toLowerCase() || "monthly";
  const cycleLabel = cycleText.charAt(0).toUpperCase() + cycleText.slice(1);
  const resolvedDescription = description
    ?? `Your ${cycleText} subscription credits are used up. New submissions will use available top-up credits until your plan renews.`;

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      destroyOnHidden
      width={480}
      className="StartTopupPoolAlertModal"
    >
      <button
        type="button"
        className="StartTopupPoolAlertModal__CloseButton"
        onClick={onClose}
        aria-label="Close top-up pool alert"
      >
        <CloseOutlined />
      </button>

      <img
        src={illustration}
        alt=""
        aria-hidden
        className="StartTopupPoolAlertModal__Illustration"
      />

      <div className="StartTopupPoolAlertModal__Copy">
        <h2 className="StartTopupPoolAlertModal__Title">{title}</h2>
        <p className="StartTopupPoolAlertModal__Description">{resolvedDescription}</p>
      </div>

      <div className="StartTopupPoolAlertModal__Summary">
        <p className="StartTopupPoolAlertModal__SummaryItem">
          {`Total credits in pool: ${Number(poolTests).toLocaleString()} credits`}
        </p>
        <span className="StartTopupPoolAlertModal__SummaryDivider" aria-hidden />
        <p className="StartTopupPoolAlertModal__SummaryItem">
          {`${cycleLabel} subscription: ${subscriptionStatus}`}
        </p>
      </div>
    </Modal>
  );
}
